import { useContext } from "react";
import DropdownContext from "./dropdown-context";

const useDropdownContext = () => {
  const context = useContext(DropdownContext);

  if (!context) {
    throw new Error(
      "Dropdown compound components cannot be rendered outside the Dropdown component",
    );
  }

  return context;
};

export default useDropdownContext;
